// Function toremap object notificationAlerts into new array with header,description,disabled flag, status flag and key for all objects.
// Every object is a type of notification
// Every type of notification will show if it's present in the alertStatus object
export const useSettingsAlertPopupMap = (alertsStatus, intl, serviceAlert, hasReportPermission, alertFeatures) => {
  const alertsMap = [
    {
      header: intl.formatMessage({ id: 't.app.settingsalert.alertHeader0.popup' }),
      description: intl.formatMessage({ id: 't.app.settingsalert.alertDesc0.popup' }),
      key: 'ALL',
      disabled: false
    },
    ...(serviceAlert
      ? [{
          header: intl.formatMessage({ id: 't.app.settingsalert.alertHeader1.popup' }),
          description: intl.formatMessage({ id: 't.app.settingsalert.alertDesc1.popup' }),
          key: 'SERVICE_ALERTS',
          disabled: true
        }]
      : []),
    {
      header: intl.formatMessage({ id: 't.app.settingsalert.alertHeader2.popup' }),
      description: intl.formatMessage({ id: 't.app.settingsalert.alertDesc2.popup' }),
      key: 'DAILY_PERFORMANCE',
      disabled: false
    },
    {
      header: intl.formatMessage({ id: 't.app.settingsalert.alertHeader3.popup' }),
      description: intl.formatMessage({ id: 't.app.settingsalert.alertDesc3.popup' }),
      key: 'MONTHLY_PERFORMANCE',
      disabled: false
    },
    {
      header: intl.formatMessage({ id: 't.app.settingsalert.alertHeader4.popup' }),
      description: intl.formatMessage({ id: 't.app.settingsalert.alertDesc4.popup' }),
      key: 'BEST_RESULTS',
      disabled: false
    },
    ...(hasReportPermission
      ? [
          {
            header: intl.formatMessage({ id: 't.app.settingsalert.alertHeader5.popup' }),
            description: intl.formatMessage({ id: 't.app.settingsalert.alertDesc5.popup' }),
            key: 'REPORT_CREATED',
            disabled: false
          },
          {
            header: intl.formatMessage({ id: 't.app.settingsalert.alertHeader6.popup' }),
            description: intl.formatMessage({ id: 't.app.settingsalert.alertDesc6.popup' }),
            key: 'REPORT_SHARED',
            disabled: false
          }
        ]
      : [])
  ]

  // Filter alertsMap based on alertFeatures from BE profile response
  // ALL is always shown; other items are filtered by alertFeatures if provided
  const hasAlertFeaturesConfig = Array.isArray(alertFeatures)
  const reportAlertKeys = ['REPORT_CREATED', 'REPORT_SHARED']
  const filteredAlertsMap = hasAlertFeaturesConfig
    ? alertsMap.filter(alert => alert.key === 'ALL' || reportAlertKeys.includes(alert.key) || alertFeatures.includes(alert.key))
    : alertsMap

  const alerstDict = {}
  if (alertsStatus) {
    const filteredEntries = Object.entries(alertsStatus).filter(([key, value]) => value === true && key !== 'SERVICE_ALERTS')
    const hasVisibleServiceAlert = filteredAlertsMap.some(alert => alert.key === 'SERVICE_ALERTS' && alert.key in alertsStatus)
    const hasVisibleEditableAlerts = filteredAlertsMap.some(alert => alert.key !== 'ALL' && alert.key !== 'SERVICE_ALERTS' && alert.key in alertsStatus)
    const hasOnlyVisibleServiceAlert = hasVisibleServiceAlert && !hasVisibleEditableAlerts
    let index = 0
    filteredAlertsMap.forEach(alert => {
      // Controlliamo se la key è presente in `data`
      if (alert.key in alertsStatus || alert.key === 'ALL') {
        alerstDict[index] = {
          ...alert,
          disabled: alert.key === 'ALL' && hasOnlyVisibleServiceAlert ? true : alert.disabled,
          status: alert.key === 'ALL' ? hasOnlyVisibleServiceAlert || filteredEntries.length !== 0 : alertsStatus[alert.key]
        }
        index++
      }
    })
  }

  return Object.values(alerstDict)
}
